import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { sendMessageToSlackChannel } from '@setvi/shared/services';
import { ThumbsUpIcon } from '@setvi/shared/components/sicons';
import { SlackMessageTypes } from '@setvi/shared/enums';
import { useDialog } from '@setvi/shared/providers';
import { Product } from '@setvi/shared/interfaces';

import Feedback, {
  FEEDBACK_DIALOG,
  FeedbackValues
} from 'componentsV2/ai/feedback';
import { FeedbackButton } from 'pages/products/styled';
import { useAppContext } from 'Providers/AppProvider/AppContext';

const SalesKitFeedback = ({
  product,
  label = 'How can we improve AI Sales Kit?'
}: {
  product: Product;
  label?: string;
}) => {
  const { user } = useAppContext();
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog, closeDialog: closeFeedbackDialog } = useDialog();

  const { mutateAsync: sendFeedback, isLoading: isFeedbackLoading } =
    useMutation(sendMessageToSlackChannel());

  const handleFeedbackClick = async ({ feedback, rating }: FeedbackValues) => {
    const body = {
      _id: process.env.SLACK_CHANNEL_ID,
      type: SlackMessageTypes.SalesEnablement,
      ...(rating ? { rating } : {}),
      feedback,
      user: {
        email: user?.Email,
        userId: user?.ID,
        company: user?.CompanyName,
        fullName: user?.FullName
      },
      results: {
        type: 'AI Generated',
        data: [product],
        value: ''
      }
    };

    const res = await sendFeedback(body);

    if (!res) return;

    closeFeedbackDialog(FEEDBACK_DIALOG);
    enqueueSnackbar('Feedback sent successfully', {
      variant: 'success'
    });
  };

  return (
    <FeedbackButton
      style={{ width: 105 }}
      variant="text"
      startIcon={<ThumbsUpIcon fill="inherit" style={{ width: 18 }} />}
      onClick={e => {
        e?.stopPropagation();
        openDialog(
          <Feedback
            onClose={() => closeFeedbackDialog(FEEDBACK_DIALOG)}
            handleSubmit={handleFeedbackClick}
            loading={isFeedbackLoading}
            label={label}
          />,
          {
            id: FEEDBACK_DIALOG
          }
        );
      }}>
      Feedback
    </FeedbackButton>
  );
};

export default SalesKitFeedback;
